import { ApplicationOfferBundleData, compareOfferBundles, getFirstOfferTab, isLargeLoanProgramOffer, ProductCode, splitLineOfCreditOffers } from "common";
import { OfferBundleData } from "../shared/offer-bundle.service";

export class OfferNavigator {
    offerBundles: OfferBundleData[];

    // Built once: templates bind these straight into child inputs, so they must keep their identity.
    readonly termOfferBundles: OfferBundleData[];
    // Standard (non large loan program) Line of Credit offers only.
    readonly locOfferBundles: OfferBundleData[];
    readonly largeLoanProgramOfferBundles: OfferBundleData[];
    readonly lawOfferBundles: OfferBundleData[];
    // The offer each product tab opens: the first of its offer tabs.
    readonly bestTermOfferBundle: OfferBundleData;
    readonly bestLocOfferBundle: OfferBundleData;
    readonly bestLargeLoanProgramOfferBundle: OfferBundleData;
    readonly bestLawOfferBundle: OfferBundleData;
    readonly currentOfferBundle: OfferBundleData;
    // The LOC tab set the current offer belongs to — standard or large loan program.
    readonly currentLocOfferBundles: OfferBundleData[];

    constructor(offerBundles: ApplicationOfferBundleData[], currentOfferBundleId: number) {
        this.offerBundles = offerBundles
            ?.sort(compareOfferBundles)
            .map(offerBundle => {
            return {
                repayment: offerBundle.offers[0]?.repaymentTerm?.toString(),
                bundleId: offerBundle.id,
                productCode: offerBundle.offers[0]?.productCode,
                amount: offerBundle.offers[0]?.amount,
                express: offerBundle.expressCheckout,
                paymentFrequency: offerBundle.offers[0]?.paymentFrequency,
                largeLoanProgram: isLargeLoanProgramOffer(offerBundle)
            };
        });

        const locOfferGroups = splitLineOfCreditOffers(this.getOfferBundlesByProductCode(ProductCode.LOC));
        this.termOfferBundles = this.getOfferBundlesByProductCode(ProductCode.Term);
        this.locOfferBundles = locOfferGroups.standard;
        this.largeLoanProgramOfferBundles = locOfferGroups.largeLoanProgram;
        this.lawOfferBundles = this.getOfferBundlesByProductCode(ProductCode.Law);

        this.bestTermOfferBundle = getFirstOfferTab(this.termOfferBundles);
        this.bestLocOfferBundle = getFirstOfferTab(this.locOfferBundles);
        this.bestLargeLoanProgramOfferBundle = getFirstOfferTab(this.largeLoanProgramOfferBundles);
        this.bestLawOfferBundle = getFirstOfferTab(this.lawOfferBundles);

        this.currentOfferBundle = this.offerBundles?.find(x => x.bundleId === currentOfferBundleId);
        this.currentLocOfferBundles = this.currentOfferBundle?.largeLoanProgram ? this.largeLoanProgramOfferBundles : this.locOfferBundles;
    }

    getOfferBundlesByProductCode(productCode:ProductCode): OfferBundleData[] {
        return this.offerBundles?.filter(offerBundle => offerBundle.productCode == productCode)
    }

    getBetterOfferBundle(offerBundle1: ApplicationOfferBundleData, offerBundle2: ApplicationOfferBundleData): ApplicationOfferBundleData {
        if (!offerBundle2) {
            return offerBundle1;
        }

        if (!offerBundle1) {
            return offerBundle2;
        }

        return offerBundle1.offers[0].amount > offerBundle2.offers[0].amount
            ? offerBundle1
            : offerBundle2;
    }
}
